export default "__VITE_ASSET__DyPd8KEy__"